import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";

const PUBLICATIONS_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_publications";
const SERVER = "https://backenddev.aaerlaw.com";

function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

function BlogOne() {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  useEffect(() => {
    fetch(`${PUBLICATIONS_API}?limit=50&page=1`)
      .then((r) => r.json())
      .then((json) => setPublications(json?.data || []))
      .catch(() => setPublications([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              Media &amp; Insights
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>Media &amp; Insights</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Blog Section */}
      <div className="blog-page-section bg-white">
        <div className="divider"></div>

        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading&hellip;</span>
              </div>
            </div>
          ) : publications.length === 0 ? (
            <div className="text-center py-5 text-muted">No publications yet.</div>
          ) : (
            <div className="row g-4">
              {publications.map((pub, idx) => {
                const snippet = stripHtml(pub.publication || "");
                const preview =
                  snippet.length > 140 ? snippet.slice(0, 140).trimEnd() + "\u2026" : snippet;
                const dateStr = new Date(pub.created_at).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
                const imgSrc = pub.image
                  ? `${SERVER}/${pub.image}`
                  : "assets/img/bg-img/16.jpg";

                return (
                  <div key={pub.id} className="col-12 col-md-6 col-lg-4">
                    <Link to={`/blogdetails?id=${pub.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                    <div
                      className="blog-card bg-secondary style-three wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay={`${300 + (idx % 3) * 100}ms`}
                    >
                      <img src={imgSrc} alt={pub.title} />
                      <div className="p-4">
                        <div className="blog-meta mt-0 d-flex align-items-center gap-2">
                          {pub.law_area && <span>{pub.law_area}</span>}
                          {pub.law_area && <div className="dot"></div>}
                          <span>{dateStr}</span>
                        </div>
                        <span className="post-title d-block mb-3">{pub.title}</span>
                        {preview && (
                          <p className="mb-2" style={{ fontSize: "0.875rem", color: "#555" }}>
                            {preview}
                          </p>
                        )}
                      </div>
                    </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default BlogOne;
